import React from "react"
import PropTypes from "prop-types"

import ReactContainer from "../ReactContainer"
import FooterNav from "./FooterNav"
import MetaTitle from "../../templates/components/MetaTitle"
import SectionLinks from "./SectionLinks"

import AccountTree from "@material-ui/icons/AccountTree"
import { withStyles } from "@material-ui/core/styles"
import Link from "../Link"

import navFooter from "../../../content/footerNav.yml"

import { colors, media } from "../../themeReact"

const styles = (theme) => ({
  footerMain: {
    backgroundColor: colors.darker,
    color: colors.white,
    paddingTop: 10,
    paddingBottom: 50,

    [theme.breakpoints.up("xl")]: {
      paddingTop: 40,
    },
  },
  containerOne: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  containerTwo: {
    flexWrap: "wrap",
    display: "flex",
    width: "100%",

    [theme.breakpoints.up("md")]: {
      width: "calc(100% / 3 * 2)",
      paddingLeft: 40,
    },
  },
  sectionLogo: {
    paddingTop: 40,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",

    [theme.breakpoints.up("md")]: {
      width: "calc(100% / 3)",
      order: -1,
    },

    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      width: "100%",
      paddingTop: 40,
    },
  },
  // for navbar logo and text
  footerLogoLink: {
    display: "flex",
    marginRight: 10,
    height: "auto",
    alignItems: "center",
    "&:hover": {
      textDecoration: "none",
    },
  },
  title: {
    font: "500 25px Roboto,sans-serif",
    cursor: "pointer",
    color: "white",
    textDecoration: "none",
    marginRight: 20,
    marginLeft: 5,
    "&:hover": {
      textDecoration: "none",
    },
  },

  imgText: {
    color: colors.subtleOnDark,
    paddingTop: 15,
  },
})

const Footer = ({ classes, layoutHasSidebar = false }) => (
  <footer className={classes.footerMain}>
    <ReactContainer>
      <div
        className={classes.containerOne}
        css={{
          [media.between("small", "medium")]: {
            paddingRight: layoutHasSidebar ? 240 : null,
          },
          [media.between("large", "largerSidebar")]: {
            paddingRight: layoutHasSidebar ? 280 : null,
          },
          [media.between("largerSidebar", "sidebarFixed", true)]: {
            paddingRight: layoutHasSidebar ? 380 : null,
          },
        }}
      >
        <div className={classes.containerTwo}>
          <FooterNav>
            <MetaTitle onDark={true}>{navFooter.dbsystem.title}</MetaTitle>
            <SectionLinks links={navFooter.dbsystem.items} />
          </FooterNav>
          <FooterNav>
            <MetaTitle onDark={true}>{navFooter.community.title}</MetaTitle>
            <SectionLinks links={navFooter.community.items} />
          </FooterNav>
        </div>
        <section className={classes.sectionLogo}>
          <Link className={classes.footerLogoLink} to="/">
            <AccountTree color="secondary" style={{ fontSize: 30 }} />
            <span className={classes.title}>DB System</span>
          </Link>
          <p className={classes.imgText}>
            {`© ${new Date().getFullYear()} NUS Database System Group`}
          </p>
        </section>
      </div>
    </ReactContainer>
  </footer>
)

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  layoutHasSidebar: PropTypes.bool.isRequired,
}

export default withStyles(styles)(Footer)
